import { SvgIcon, type SvgIconProps } from "@mui/material";
import type { FC } from "react";

export const FormatTextColour: FC<{ textColour: string; sx: SvgIconProps["sx"] }> = (props) => {
  return (
    <SvgIcon viewBox="0 0 24 24" sx={props.sx}>
      <path
        d="M2 20v4H2zm3.49-3h2.42l1.27-3.58h5.65L16.09 17h2.42L13.25 3h-2.5zm4.42-5.61 2.03-5.79h.12l2.03 5.79z"
        fill="currentColor"
      />
      <path d="M2 24h20" stroke={props.textColour || "currentColor"} strokeWidth="8" />
    </SvgIcon>
  );
};
